import { createSelector } from 'reselect';

export const getUser = (state) => state.user;

const UserSelectors = {
  makeUser: createSelector([getUser], (user) => user),
  makeApplicationsEnabled: createSelector([getUser], (user) => user.applicationsEnabled),
  makeIsLoggedIn: createSelector([getUser], (user) => user.loggedIn),
  makeIsEmailVerified: createSelector([getUser], (user) => user.isEmailVerified),
  makeIsHousingConnector: createSelector([getUser], (user) => user.isHousingConnector),
  makeIsMultifamilyCustomer: createSelector([getUser], (user) => user.isMultifamilyCustomer),
  makeIsRocketshipCustomer: createSelector([getUser], (user) => user.isRocketshipCustomer),
  makeIsTwoFactorAuthEnabled: createSelector([getUser], (user) => user.isTwoFactorAuthEnabled),
  makeIsUserAllowed: createSelector([getUser], (user) => user.restrictions.isAllowed),
  makeImpersonatorUserToken: createSelector([getUser], (user) => user.impersonatorUserToken),
  makeUserToken: createSelector([getUser], (user) => user.userToken),
  makeEmail: createSelector([getUser], (user) => user.email),
  makePhoneNumber: createSelector([getUser], (user) => user.phoneNumber),
  makeOriginalServerSideRequestCookies: createSelector([getUser], (user) => user.originalServerSideRequestCookies),
  makeHasPaidForListing: (state) => getUser(state).hasPaidForListing,
  makeSummary: createSelector([getUser], (user) => user.summary),
  makeIsIdVerified: createSelector([getUser], (user) => user.isIdVerified),
};

export default UserSelectors;
